import jwt from "jsonwebtoken";

export function getAuthToken(): any {
  const windowGlobal = typeof window !== "undefined" && window;
  if (windowGlobal) {
    return windowGlobal.localStorage.getItem("token");
  }
  return null;
}

export function getAuthCredentials(): any {
  const token = getAuthToken();
  if (token) {
    return jwt.decode(token);
  }
  return null;
}

export function getHostname(sub: string, forceInsecure?: boolean): string {
  const { hostname } = window.location;
  let { protocol } = window.location;
  if (sub === "preview" && forceInsecure) {
    protocol = "http:";
  }
  if (hostname === "localhost" && sub === "api") {
    return `${protocol}//app.dylan.local/api`;
  }
  if (hostname === "localhost" && sub === "api") {
    return `${protocol}//localhost:8370/api`;
  }
  const split = hostname.split(".");
  if (split.length === 2) {
    return `${protocol}//${sub}.${hostname}`;
  } else {
    // This isn't super elegant, but it's explicit and simple
    if (sub === "api") {
      if (hostname === "staging.shorthand.com") {
        return `${protocol}//staging-api.shorthand.com`;
      } else {
        // For test branches, use the corresponding test API
        if (hostname.includes(".g.shorthand.com")) {
          return `${protocol}//test-gro-1687-enable-gatsby-signup-api.test.shorthand.com`;
        }
        return `${protocol}//staging-api.shorthand.com`;
      }
    }
  }
}

export function getAppHostname(): string {
  const { hostname, protocol } = window.location;

  if (hostname === "localhost") {
    return `${protocol}//localhost:9443`;
  }

  if (hostname === "staging.shorthand.com") {
    return `${protocol}//staging-app.shorthand.com`;
  }

  // For test branches
  if (hostname.includes(".g.shorthand.com")) {
    return `${protocol}//test-gro-1687-enable-gatsby-signup.test.shorthand.com`;
  }

  // Default to production
  return `${protocol}//app.shorthand.com`;
}
